module.exports = __webpack_public_path__ + "img/work2.ef2a1211.png";